const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function zonedParts(date, timeZone) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone,
    weekday: "short",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);

  const map = {};
  parts.forEach((part) => {
    map[part.type] = part.value;
  });

  return {
    weekday: map.weekday,
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
    hour: Number(map.hour),
    minute: Number(map.minute),
    second: Number(map.second),
  };
}

function addDays(parts, days) {
  const utc = Date.UTC(parts.year, parts.month - 1, parts.day + days);
  const next = new Date(utc);

  return {
    year: next.getUTCFullYear(),
    month: next.getUTCMonth() + 1,
    day: next.getUTCDate(),
    weekday: WEEKDAYS[next.getUTCDay()],
  };
}

function isWeekend(weekday) {
  return weekday === "Sat" || weekday === "Sun";
}

function nextWeekday(parts) {
  let next = addDays(parts, 1);

  while (isWeekend(next.weekday)) {
    next = addDays(next, 1);
  }

  return next;
}

function zonedTimeToDate(parts, timeZone) {
  const utcGuess = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour || 0,
    parts.minute || 0,
    parts.second || 0,
  );
  const guessParts = zonedParts(new Date(utcGuess), timeZone);
  const guessWall = Date.UTC(
    guessParts.year,
    guessParts.month - 1,
    guessParts.day,
    guessParts.hour,
    guessParts.minute,
    guessParts.second,
  );
  const desiredWall = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour || 0,
    parts.minute || 0,
    parts.second || 0,
  );

  return new Date(utcGuess + (desiredWall - guessWall));
}

function pad(value) {
  return String(value).padStart(2, "0");
}

function formatDeliveryDate(parts) {
  return `${parts.weekday} ${pad(parts.day)} ${MONTHS[parts.month - 1]}`;
}

function formatDuration(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

function getCountdownState(now, cutoffHour, timeZone) {
  const nowParts = zonedParts(now, timeZone);
  const nowSeconds = nowParts.hour * 3600 + nowParts.minute * 60 + nowParts.second;
  const cutoffSeconds = cutoffHour * 3600;
  const beforeCutoff = !isWeekend(nowParts.weekday) && nowSeconds < cutoffSeconds;
  const processDay = beforeCutoff ? nowParts : nextWeekday(nowParts);
  const deliveryDay = nextWeekday(processDay);
  const cutoffParts = {
    ...processDay,
    hour: cutoffHour,
    minute: 0,
    second: 0,
  };

  return {
    remainingMs: zonedTimeToDate(cutoffParts, timeZone) - now,
    deliveryLabel: formatDeliveryDate(deliveryDay),
  };
}

function initDeliveryCountdown(root) {
  const timerEl = root.querySelector("[data-delivery-countdown-timer]");
  const dateEl = root.querySelector("[data-delivery-countdown-date]");
  if (!timerEl || !dateEl) return;

  const cutoffHour = Number(root.dataset.cutoffHour || 14);
  const timeZone = root.dataset.timezone || "Europe/London";

  const tick = () => {
    const state = getCountdownState(new Date(), cutoffHour, timeZone);
    timerEl.textContent = formatDuration(state.remainingMs);
    dateEl.textContent = state.deliveryLabel;
  };

  tick();
  window.setInterval(tick, 1000);
}

function initAllDeliveryCountdowns() {
  document.querySelectorAll("[data-delivery-countdown]").forEach(initDeliveryCountdown);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllDeliveryCountdowns);
} else {
  initAllDeliveryCountdowns();
}
